export interface PackageFeature {
  label: string
}

export interface ServicePackage {
  id: 'pilot' | 'copilot'
  name: string
  badge?: string
  monthly: string
  onboardingStandard: string
  onboardingOffer: string
  totalDueToStart: string
  featuresHeading: string
  features: string[]
  featured: boolean
}

export const packages: ServicePackage[] = [
  {
    id: 'pilot',
    name: 'Pilot',
    monthly: '$615',
    onboardingStandard: '$997',
    onboardingOffer: '$499',
    totalDueToStart: '$1,114',
    featuresHeading: 'What you get',
    features: [
      'Mobile-responsive website',
      'AI phone attendant answering 24/7',
      'Review automation',
      'Full CRM — your own 1Dash.Pro account',
      '1 business phone number',
    ],
    featured: false,
  },
  {
    id: 'copilot',
    name: 'Co-Pilot',
    badge: 'Best Value — Onboarding Free',
    monthly: '$1,235',
    onboardingStandard: '$997',
    onboardingOffer: 'FREE',
    totalDueToStart: '$1,235',
    featuresHeading: 'Everything in Pilot, plus',
    features: [
      'Directory listings + weekly Google Business Profile posts',
      '2 business phone numbers',
      '10 branded email accounts',
      'Managed hosting + weekly backups',
    ],
    featured: true,
  },
]
